import styled from 'styled-components';
import { colorBlack900, fontFamilyPrimary, mediaQueryMobileMin } from 'styles';

export const DropWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 16px;

  &:before {
    content: '';
    width: calc(100vw - 32px - 240px);
    height: 1px;
    background: #e5e5e5;
  }
  &:after {
    content: '';
    width: calc(100vw - 32px - 240px);
    height: 1px;
    background: #e5e5e5;
  }

  @media all and ${mediaQueryMobileMin} {
    &:before {
      width: 35%;
    }
    &:after {
      width: 35%;
    }
  }
`;

export const DropButton = styled.button`
  width: 240px;
  height: 40px;
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 24px;
  background: #fff;
  border: 1px solid #cacccb;
  border-radius: 30px;
  color: ${colorBlack900};

  &:hover {
    background: #f2f3f2;
  }
`;
